import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useQuery } from 'react-apollo-hooks';

import { setSentryUser, getRefreshToken, ProfileContext } from '@loyalup/core';

const ProfileLoader = ({ children, query }) => {
  const { data } = useQuery(query, { suspend: true });
  const user = data.me;
  const locale = (user && user.locale) || 'ru';

  const [, i18n] = useTranslation();

  useEffect(() => {
    locale && i18n.changeLanguage(locale.toLowerCase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  setSentryUser(user);
  return <ProfileContext.Provider value={user}>{children}</ProfileContext.Provider>;
};

let tokenLoading = false;
let token;

const ProfileLoaderContainer = ({ query, children }) => {
  const getToken = () => {
    tokenLoading = true;
    return getRefreshToken().then(t => {
      token = t;
    });
  };
  if (!tokenLoading) throw getToken();
  return token ? <ProfileLoader query={query}>{children}</ProfileLoader> : children;
};

ProfileLoaderContainer.propTypes = {
  children: PropTypes.node.isRequired,
  query: PropTypes.object.isRequired,
};

export default ProfileLoaderContainer;
